import { INIT, INIT_FAILED, INIT_SUCCESS } from './constants';

export type InitAction = { type: typeof INIT };
export type InitSuccessAction = { type: typeof INIT_SUCCESS };
export type InitFailedAction = { type: typeof INIT_FAILED; error: unknown };

export type DonationsSeedActions = InitAction | InitSuccessAction | InitFailedAction;

export const initAction = (): InitAction => ({ type: INIT });

export const initSuccessAction = (): InitSuccessAction => ({
  type: INIT_SUCCESS,
});

export const initFailedAction = (error: unknown): InitFailedAction => ({
  type: INIT_FAILED,
  error,
});
